// extracted by mini-css-extract-plugin
export default {"envMessage":"envMessage__envMessage--aJMkg0W","isHovering":"envMessage__isHovering--X41ReI9","stg":"envMessage__stg--gJ8IDUv","qa":"envMessage__qa--sJNDWL5"};